import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions"
import { getDatabase, connectDatabaseEmulator } from "firebase/database";
import { getStorage, connectStorageEmulator } from "firebase/storage";


const firebaseConfig = {
    apiKey: "AIzaSyCngWMI50_ZHDA9UYhk55TzobH6yMyk1NM",
    authDomain: "blat-unum.firebaseapp.com",
    databaseURL: "https://blat-unum-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "blat-unum",
    storageBucket: "blat-unum.appspot.com",
    messagingSenderId: "947432604229",
    appId: "1:947432604229:web:774784eb91c4b6fe07592c"
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app)

export const db = getFirestore(app);

export const database = getDatabase(app);

export const storage = getStorage(app)

export const functions = getFunctions(app);

if (
    window.location.hostname == "localhost"
) {
    connectFunctionsEmulator(getFunctions(app), 'localhost', 5001)
    connectFirestoreEmulator(getFirestore(app), 'localhost', 8088)
    connectDatabaseEmulator(getDatabase(app), 'localhost', 9000)
    connectStorageEmulator(getStorage(app), 'localhost', 9199)
    connectAuthEmulator(getAuth(app), 'http://localhost:9099')
}

export default app
